/* Utils */
import { generateEntityActionTypes } from '../utils/generators/actionTypeGenerators';

const ENTITY_NAME = 'PAGES';

export const FETCH_PAGE_BY_ID = `${ENTITY_NAME}/FETCH/BY_ID`;
export const PAGE_ENTITY_ACTION_TYPES = generateEntityActionTypes(ENTITY_NAME);
